import { render } from "./LightThemeAlert.vue?vue&type=template&id=1237bcb6&scoped=true"
import script from "./LightThemeAlert.vue?vue&type=script&lang=js"
export * from "./LightThemeAlert.vue?vue&type=script&lang=js"

import "./LightThemeAlert.vue?vue&type=style&index=0&id=1237bcb6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1237bcb6"]])

export default __exports__